import { render, staticRenderFns } from "./TreasuryEdit.vue?vue&type=template&id=05065de8&scoped=true&"
import script from "./TreasuryEdit.vue?vue&type=script&lang=js&"
export * from "./TreasuryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05065de8",
  null
  
)

export default component.exports